export default __webpack_public_path__ + "static/media/Aeonik-Medium.d6636926.woff";